import { connect } from 'react-redux';
// @ts-expect-error Untyped Dependency
import CommonMessage from 'conversations-visitor-message-history/common-message/CommonMessage';
import { isStarted } from '../../../threads/operators/isStarted';
import { isClosed } from '../../../threads/operators/isClosed';
import { isPersistedThread } from '../../../threads/operators/isPersistedThread';

// @ts-expect-error Untyped Dependency
import { publishVisitorMessage } from '../../../pubsub/actions/publishVisitorMessage';
import { dispatchFeedbackChain } from '../../../pubsub/actions/dispatchFeedbackChain';
// @ts-expect-error Untyped Dependency
import { hasUnansweredQuickReplyMessage } from '../../../selectors/chatSelectors';
// @ts-expect-error Untyped Dependency
import { getSelectedThread } from '../../../selected-thread/selectors/getSelectedThread';
import { toggleOpen } from '../../../actions/WidgetActions';
import { getIsMobile } from '../../../selectors/getIsMobile';
import { getWidgetDataLanguage, getIsUngatedForCustomerAgentFeedback } from '../../../widget-data/selectors/widgetDataSelectors';
import { trackInteraction } from '../../../usage-tracking/actions/trackInteraction';
import { navigateToKnowledgeBaseArticle } from '../../../navigation/actions/navigateToKnowledgeBaseArticle';
import { withBrowserSizeContext } from '../../../containers/withBrowserSizeContext';
// @ts-expect-error Untyped Dependency
import { getFilteredMessages } from '../../selectors/getFilteredMessages';
import { getColoring } from '../../../selectors/widgetDataSelectors/getColoring';
import { postQuickLinkButtonClickEvent } from '../../../pubsub/actions/postQuickLinkButtonClickEvent';
import { isSpeechPocPortal } from '../../../utils/isSpeechPocPortal';
import { getUnpublishedMessagesForCurrentThread } from '../../../pubsub/selectors/getUnpublishedMessagesForCurrentThread';
// @ts-expect-error Untyped Dependency
import { getCurrentThreadHistoryData } from '../../selectors/getCurrentThreadHistoryData';
// @ts-expect-error Untyped Dependency
import { getCurrentThreadHistoryEntry } from '../../selectors/getCurrentThreadHistoryEntry';
import { isSucceeded, isFailed } from '../../../constants/asyncStatuses';
const mapStateToProps = state => {
  var _state$speechPoc, _state$speechPoc2;
  const selectedThread = getSelectedThread(state);
  const coloring = getColoring(state);
  const isPersisted = isPersistedThread(selectedThread);
  return {
    hasUnansweredQuickReplyMessage: hasUnansweredQuickReplyMessage(state, {
      thread: selectedThread
    }),
    isThreadStarted: isStarted(selectedThread),
    mobile: getIsMobile(state),
    locale: getWidgetDataLanguage(state),
    messagesList: getFilteredMessages(state),
    unpublishedMessages: getUnpublishedMessagesForCurrentThread(state),
    threadHistoryData: getCurrentThreadHistoryData(state),
    isThreadHistoryLoaded: !isPersisted || isSucceeded(getCurrentThreadHistoryEntry(state)) || isFailed(getCurrentThreadHistoryEntry(state)),
    speechPocActive: isSpeechPocPortal() && ((_state$speechPoc = state.speechPoc) === null || _state$speechPoc === void 0 ? void 0 : _state$speechPoc.speechPocActive),
    audioPlaybackStatus: (_state$speechPoc2 = state.speechPoc) === null || _state$speechPoc2 === void 0 ? void 0 : _state$speechPoc2.audioPlaybackStatus,
    accentColor: coloring.accentColor,
    isUngatedForCustomerAgentFeedback: getIsUngatedForCustomerAgentFeedback(state),
    isThreadClosed: isClosed(selectedThread)
  };
};
const mapDispatchToProps = {
  navigateToKnowledgeBaseArticle,
  publishMessage: publishVisitorMessage,
  dispatchFeedbackChain,
  toggleOpen,
  trackInteraction,
  onQuickLinkClick: postQuickLinkButtonClickEvent
};
export default connect(mapStateToProps, mapDispatchToProps)(withBrowserSizeContext(CommonMessage));